import { Box, Button, Grid } from "@mui/material";
import { TransForm } from "../../common/TransForm/Index";
import leagueFormSystem from "../../common/jsons/formConfigs/leagueFormSystem";
import leagueFormManual from "../../common/jsons/formConfigs/leagueFormManual";
import { PageTitle } from "../../common/PageTitle";
import Divider from '@mui/material/Divider';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import _ from "lodash";
import { useEffect, useState } from "react";
import { Typography } from "antd";
import ModalPopUp from "../../common/TransForm/ModalPopUp";
import { base_url } from "../../backendurl/url";
import Axios from "axios";
import { Config } from "../../../utils/commonFuctions/Token";
import { Notification } from "../../common/Notification";
import { RefreshToken } from "../../../utils/commonFuctions/RefreshToken";
import { setSelectedLeague } from "../../../redux/action";

export const LeagueForm = ({ mode }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  
  const defaultColors = {
    card_color: "#3D185D",
    btn_text_color: "#FFFFFF",
    btn_background_color: "#00C05B",
    progress_bar_color: "#0080FE"
  };

  const [popup, setPopup] = useState(false);
  const [leagues, setLeaguesData] = useState([]);
  const [games, setGamesData] = useState([]);
  const [selectedGame, setSelectedGame] = useState('');
  
  // Use selectedLeague instead of selectedLeagues for single league
  const { selectedLeague } = useSelector((state) => state);
  
  const [ismanual, setIsmanual] = useState('');
  const navigate = useNavigate();
  const [leaguedata, setLeagues] = useState({});
  const [shownotification, setShownotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [formKey, setFormKey] = useState(0);
  const [formColors, setFormColors] = useState(defaultColors);
  const [currentFormData, setCurrentFormData] = useState({});
  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  
  // Add states for edit functionality
  const [currentLeagueData, setCurrentLeagueData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  
  // Define predefined league colors
  const predefinedLeagueColors = {
    78: { // Bundesliga
      card_color: "#FFFFFF",
      btn_text_color: "#FFFFFF",
      btn_background_color: "#D34343",
      progress_bar_color: "#0080FE"
    },
    2: { // UEFA Champions League
      card_color: "#253869",
      btn_text_color: "#FFFFFF",
      btn_background_color: "#00C05B",
      progress_bar_color: "#0080FE"
    },
    140: { // La Liga
      card_color: "#FF4B44",
      btn_text_color: "#FF4F48",
      btn_background_color: "#FFFFFF",
      progress_bar_color: "#FFFFFF"
    },
    871: { // Premier League Cup - England
      card_color: "#3D185D",
      btn_text_color: "#FFFFFF",
      btn_background_color: "#00C05B",
      progress_bar_color: "#0080FE"
    }
  };

  // Get page title based on mode
  const getPageTitle = () => {
    switch (mode) {
      case 'view':
        return 'View League Details';
      case 'edit':
        return 'Edit League Configuration';
      default:
        return ismanual === 'manual' ? 'Configuring New League Manually' : 'Configuring New League';
    }
  };

  // Get subtitle based on mode
  const getSubTitle = () => {
    switch (mode) {
      case 'view':
        return 'League details are displayed below';
      case 'edit':
        return 'Update the league configuration below';
      default:
        return 'Enter the data below to configure a new league';
    }
  };

  // Load league data for view/edit modes
  // const loadLeagueData = async () => {
  //   if ((mode === 'view' || mode === 'edit') && id) {
  //     setIsLoading(true);
  //     try {
  //       // First check if we have data in Redux
  //       if (!_.isEmpty(selectedLeague) && selectedLeague.id == id) {
  //         console.log("Using Redux data:", selectedLeague);
  //         setCurrentLeagueData(selectedLeague);
  //         setIsmanual(selectedLeague.league_id ? 'system' : 'manual');
          
  //         // Set the selected game from league data
  //         if (selectedLeague.game) {
  //           setSelectedGame(selectedLeague.game);
  //         }
  //       } else {
  //         // Fetch from API if Redux data is not available
  //         console.log("Fetching from API...");
  //         const response = await Axios.get(`${base_url}/api/pot/configureleagues/${id}`, Config);
          
  //         if (response?.status === 200) {
  //           const leagueData = response.data.data;
  //           console.log("Fetched league data:", leagueData);
  //           setCurrentLeagueData(leagueData);
            
  //           // Store in Redux for future use
  //           dispatch(setSelectedLeague(leagueData));
            
  //           // Determine if it's system or manual based on league_id presence
  //           setIsmanual(leagueData.league_id ? 'system' : 'manual');
            
  //           // Set the selected game from league data
  //           if (leagueData.game) {
  //             setSelectedGame(leagueData.game);
  //           }
  //         }
  //       }
  //     } catch (error) {
  //       console.error('Error loading league data:', error);
  //       RefreshToken(error, setErrorMessage, setShownotification);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   }
  // };

  const loadLeagueData = async () => {
  if ((mode === 'view' || mode === 'edit') && id) {
    setIsLoading(true);
    try {
      let leagueData = null;
      
      // First check if we have data in Redux
      if (!_.isEmpty(selectedLeague) && selectedLeague.id == id) {
        console.log("Using Redux data:", selectedLeague);
        leagueData = selectedLeague;
      } else {
        // Fetch from API if Redux data is not available
        console.log("Fetching from API...");
        const response = await Axios.get(`${base_url}/api/pot/configureleagues/${id}`, Config);
        
        if (response?.status === 200) {
          leagueData = response.data.data;
          console.log("Fetched league data:", leagueData);
          
          // Store in Redux for future use
          dispatch(setSelectedLeague(leagueData));
        }
      }

      if (leagueData) {
        console.log("Setting league data:", leagueData);
        setCurrentLeagueData(leagueData);
        
        // Initialize currentFormData with empty object for edit mode
        // This allows the form to be editable while still showing initial values
        setCurrentFormData({});
        
        // Determine if it's system or manual based on league_id presence
        setIsmanual((leagueData.system_league === true) ? 'system' : 'manual');
        
        // Set the selected game from league data
        if (leagueData.game) {
          setSelectedGame(leagueData.game);
        }
      }
    } catch (error) {
      console.error('Error loading league data:', error);
      RefreshToken(error, setErrorMessage, setShownotification);
    } finally {
      setIsLoading(false);
    }
  }
};
console.log("Fetched league data123:", currentLeagueData);
  // Function to get games from API
  const getGames = async () => {
    try {
      const response = await Axios.get(`${base_url}/api/pot/games`, Config);
      let gamesData = response?.data?.data.map((item) => {
        return {
          id: item?.id,
          name: item?.game_name,
          ...item
        }
      });
      setGamesData(gamesData);
    } catch (error) {
      RefreshToken(error, setErrorMessage, setShownotification);
    }
  };

  // Function to validate game selection
  const validateGameSelection = (gameId) => {
    const selectedGameData = games.find(game => game.id === gameId);
    if (selectedGameData && selectedGameData.name.toLowerCase() !== 'football') {
      setErrorMessage('Not have leagues list you can only selected as football value');
      setShownotification(true);
      setFieldsDisabled(true);
      return false;
    }
    setFieldsDisabled(false); 
    return true;
  };

  const onSubmit = async (data) => {
    // Validate game selection first
    if (!validateGameSelection(data.game_id)) {
      return;
    }

    if (mode === 'edit') {
      // Handle edit mode
      let updatedData = {
        ...data,
        card_color: data?.card_color || "#3D185D",
        btn_text_color: data?.btn_text_color || "#FFFFFF",
        btn_background_color: data?.btn_background_color || "#00C05B",
        progress_bar_color: data?.progress_bar_color || "#0080FE",
        game: data?.game_id, // Add game_id to payload
      };

      if (ismanual === 'system') {
        const filterdata = leagues?.find(item => item.id === data.league_name);
        updatedData = {
          ...updatedData,
          league_id: filterdata?.system_league_id || data.league_id,
          name: filterdata?.name || data.name,
        };
      }

      setLeagues(updatedData);
      setPopup(true);
    } else {
      // Handle create mode
      if (ismanual === 'system') {
        const filterdata = leagues?.find(item => item.id === data.league_name);
        
        // Get colors based on league selection
        const selectedLeagueId = filterdata?.system_league_id || filterdata?.league_id;
        const predefinedColors = predefinedLeagueColors[selectedLeagueId];
        
        let colors;
        if (predefinedColors) {
          // Use predefined colors for specific leagues
          colors = predefinedColors;
        } else {
          // Use entered colors or default colors for other leagues
          colors = {
            card_color: data?.card_color || defaultColors.card_color,
            btn_text_color: data?.btn_text_color || defaultColors.btn_text_color,
            btn_background_color: data?.btn_background_color || defaultColors.btn_background_color,
            progress_bar_color: data?.progress_bar_color || defaultColors.progress_bar_color
          };
        }
        
        await Promise.resolve(); 
        setLeagues({
          league_id: selectedLeagueId ? selectedLeagueId : '',
          name: filterdata?.name,
          active: data?.is_active,
          game: data?.game_id, // Add game_id to payload
          ...colors
        });
      } else {
        // For manual entry, use entered colors or default colors
        const colors = {
          card_color: data?.card_color || defaultColors.card_color,
          btn_text_color: data?.btn_text_color || defaultColors.btn_text_color,
          btn_background_color: data?.btn_background_color || defaultColors.btn_background_color,
          progress_bar_color: data?.progress_bar_color || defaultColors.progress_bar_color
        };
        
        setLeagues({
          name: data?.name,
          active: data?.is_active,
          game: data?.game_id, // Add game_id to payload
          ...colors
        });
      }
      setPopup(true);
    }
  };

  const getTeamLeagues = async () => {
    if (mode !== 'view' && mode !== 'edit') {
      setIsmanual('');
    }
    try {
      const response = await Axios.get(`${base_url}/api/pot/leagues`, Config);
      let leaguename = response?.data?.data.map((item) => {
        return {
          ...item,
          id: item?.league_id,
          name: `${item?.league_name} - ${item?.country}`,
          system_league_id: item?.system_league_id // Store original league_id
        }
      });
      setLeaguesData(leaguename);
    } catch (error) {
      RefreshToken(error, setErrorMessage, setShownotification);
    }
  };

  useEffect(() => {
    // Load data in proper sequence
    const loadData = async () => {
      await getGames(); // Fetch games first
      await getTeamLeagues(); // Then fetch leagues
      await loadLeagueData(); // Finally load league data for edit/view
    };
    loadData();
  }, [id, mode]);

  const SubmitTeams = async () => {
    try {
      console.log(leaguedata, "leaguedata123");
      
      let response;
      if (mode === 'edit') {
        response = await Axios.patch(`${base_url}/api/pot/configureleagues/${id}`, leaguedata, Config);
      } else {
        response = await Axios.post(`${base_url}/api/pot/configureleagues/create/`, leaguedata, Config);
      }
console.log("Response from API123:", response);
      if (response?.data.status === 'Success' || response?.status === 200) {
        setPopup(false);
        setLeagues({});
        setCurrentFormData({});
        setSelectedGame('');
        setFormKey(prev => prev + 1);
        
        // Clear Redux data
        dispatch(setSelectedLeague({}));
        
        navigate('/configurations/leagues');
      }
    } catch (error) {
      if (error.response?.status === 422) {
        setErrorMessage(mode === 'edit' ? 'Failed to update league' : 'League already exists');
        setShownotification(true);
        setPopup(false);
        setLeagues({});
        setCurrentFormData({});
        setSelectedGame('');
        setFormKey(prev => prev + 1);
      } else {
        RefreshToken(error, setErrorMessage, setShownotification);
      }
    }
  };

  // Function to handle mode change and reset form
  const handleModeChange = (selectedMode) => {
    setIsmanual(selectedMode);
    setLeagues({});
    setCurrentFormData({});
    setSelectedGame('');
    setFormColors();
    setFormKey(prev => prev + 1);
    setFieldsDisabled(false);
  };

  // Format data for form display with proper dropdown value mapping
 const getFormData = () => {
  if (mode === 'view' || mode === 'edit') {
    console.log(currentLeagueData, "currentLeagueDataEditView");
    console.log(currentFormData, "currentFormData from user input");
    console.log(leagues, "available leagues for dropdown");
    
    // Start with the original league data
    let formData = {
      ...currentLeagueData,
      is_active: currentLeagueData.active,
      game_id: currentLeagueData.game,
    };

    // Handle system league mapping for the initial load
    if (ismanual === 'system' && !currentFormData.league_name) {
      const matchedLeague = leagues.find(l => l.system_league_id === currentLeagueData.league_id);
      if (matchedLeague) {
        formData.league_name = matchedLeague.id;
      } else {
        formData.league_name = currentLeagueData.league_id;
      }
    } else if (ismanual === 'manual' && !currentFormData.league_name) {
      formData.league_name = currentLeagueData.name;
    }

    // IMPORTANT: Merge with current form data to allow updates
    // This ensures that any changes made by the user are preserved
    formData = {
      ...formData,
      ...currentFormData // This will override with user's changes
    };

    console.log("Final merged form data:", formData);
    return formData;
  }
  
  return currentFormData || {}; // For create mode, just return current form data
};

  const handleBackToList = () => {
    // Clear Redux data when going back
    dispatch(setSelectedLeague({}));
    navigate('/configurations/leagues');
  };

  // Show loading state while fetching data
  if (isLoading && (mode === 'view' || mode === 'edit')) {
    return (
      <Box sx={{ px: 6, py: 3, textAlign: 'center' }}>
        <Typography>Loading league data...</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ px: 6, py: 3 }} alignContent="center">
        <PageTitle pageTitle={getPageTitle()} />
        <Typography>{getSubTitle()}</Typography>
        {/* {(mode === 'view' || mode === 'edit') && (
          <Button 
            onClick={handleBackToList}
            sx={{ 
              mt: 2, 
              backgroundColor: '#6B7280', 
              color: '#fff', 
              px: 3, 
              borderRadius: 1,
              '&:hover': { backgroundColor: '#4B5563' }
            }}
          >
            ← Back to List
          </Button>
        )} */}
      </Box>
      <Divider sx={{ mb: 2, height: 4 }} />
      
      {/* Mode selection - only show for create mode */}
      {mode !== 'view' && mode !== 'edit' && ismanual === '' && (
        <Box sx={{ px: 6, py: 3 }} alignContent="center">
          <Button 
            onClick={() => handleModeChange('system')} 
            sx={{ 
              mr: 2, 
              backgroundColor: '#3C50E0', 
              color: '#fff', 
              px: 4, 
              borderRadius: 1, 
              border: '1px solid #3C50E0', 
              '&:hover': { backgroundColor: '#3C50E0', border: '1px solid #3C50E0' } 
            }}
          > 
            Fetch Leagues 
          </Button>
          <Button 
            onClick={() => handleModeChange('manual')} 
            sx={{ 
              mr: 2, 
              backgroundColor: '#FFF', 
              color: '#000', 
              px: 4, 
              borderRadius: 1, 
              border: '1px solid #E2E8F0', 
              '&:hover': { backgroundColor: '#FFF', border: '1px solid #E2E8F0' } 
            }}
          > 
            Manually Add Leagues 
          </Button>
        </Box>
      )}

      {/* Form rendering - only render when data is loaded */}
      {(ismanual !== '' || mode === 'view' || mode === 'edit') && leagues.length > 0 && games.length > 0 && (
        <>
          {ismanual === 'system' ? (
            <TransForm
              key={formKey}
              submitAction={onSubmit}
              data={getFormData()}
              mode={mode}
//               getFormData={(formData) => {
//   console.log(formData, "formDataValues");
  
//   // Update current form data by merging with previous data
//   const updatedFormData = { ...currentFormData, ...formData };
//   console.log(updatedFormData, "updatedFormData");
//   setCurrentFormData(updatedFormData);
  
//   // Handle game selection change
//   if (formData.game_id && formData.game_id !== currentFormData.game_id) {
//     setSelectedGame(formData.game_id);
    
//     // Validate game selection
//     const selectedGameData = games.find(game => game.id === formData.game_id);
//     if (selectedGameData && selectedGameData.name.toLowerCase() !== 'football') {
//       setErrorMessage('Not have leagues list you can only selected as football value');
//       setShownotification(true);
//       setFieldsDisabled(true);
//       return;
//     } else {
//       setFieldsDisabled(false);
//     }
//   }
  
//   // Handle league selection change for auto-filling colors (only in create mode)
//   if (mode !== 'view' && mode !== 'edit' && formData.league_name && formData.league_name !== currentFormData.league_name) {
//     console.log(formData, "league_name");
//     const selectedLeague = leagues?.find(league => league.id === formData.league_name);
//     console.log(selectedLeague, "selectedLeague11");
//     if (selectedLeague) {
//       const leagueId = selectedLeague.system_league_id || selectedLeague.league_id;
//       const predefinedColors = predefinedLeagueColors[leagueId];
      
//       if (predefinedColors) {
//         const newColors = { ...predefinedColors };
//         setFormColors(newColors);
        
//         const updatedWithColors = { ...updatedFormData, ...newColors };
//         setCurrentFormData(updatedWithColors);
//       } else {
//         setFormColors();
        
//         const updatedWithColors = { 
//           ...updatedFormData,  
//           card_color: '',
//           progress_bar_color: '',
//           btn_text_color: '',
//           btn_background_color: '' 
//         };
//         setCurrentFormData(updatedWithColors);
//       }
//     }
//   }
// }}
// getFormData={(formData) => {
//   console.log(formData, "formDataValues");
  
//   // Update current form data by merging with previous data
//   const updatedFormData = { ...currentFormData, ...formData };
//   console.log(updatedFormData, "updatedFormData");
//   setCurrentFormData(updatedFormData);
  
//   // Handle game selection change
//   if (formData.game_id && formData.game_id !== currentFormData.game_id) {
//     setSelectedGame(formData.game_id);
    
//     // Validate game selection
//     const selectedGameData = games.find(game => game.id === formData.game_id);
//     if (selectedGameData && selectedGameData.name.toLowerCase() !== 'football') {
//       setErrorMessage('Not have leagues list you can only selected as football value');
//       setShownotification(true);
//       setFieldsDisabled(true);
//       return;
//     } else {
//       setFieldsDisabled(false);
//     }
//   }
  
//   // Handle league selection change for auto-filling colors 
//   // CHANGED: Removed the mode restriction to allow auto-fill in edit mode as well
//   if (formData.league_name && formData.league_name !== currentFormData.league_name) {
//     console.log(formData, "league_name");
//     const selectedLeague = leagues?.find(league => league.id === formData.league_name);
//     console.log(selectedLeague, "selectedLeague11");
//     if (selectedLeague) {
//       const leagueId = selectedLeague.system_league_id || selectedLeague.league_id;
//       console.log("Selected league ID:", leagueId);
//       const predefinedColors = predefinedLeagueColors[leagueId];
//       console.log("Predefined colors found:", predefinedColors);
      
//       // Check if this league has predefined colors (78, 2, 140, 871)
//       if (predefinedColors) {
//         console.log("Auto-filling colors for league ID:", leagueId);
//         const newColors = { ...predefinedColors };
//         setFormColors(newColors);
        
//         // Update current form data with new colors
//         const updatedWithColors = { ...updatedFormData, ...newColors };
//         setCurrentFormData(updatedWithColors);
//       } else {
//         // Clear colors for non-predefined leagues (only in create mode)
//         if (mode !== 'view' && mode !== 'edit') {
//           setFormColors();
          
//           const updatedWithColors = { 
//             ...updatedFormData,  
//             card_color: '',
//             progress_bar_color: '',
//             btn_text_color: '',
//             btn_background_color: '' 
//           };
//           setCurrentFormData(updatedWithColors);
//         }
//         // In edit mode, keep existing colors if no predefined colors found
//       }
//     }
//   }
// }}
getFormData={(formData) => {
  console.log(formData, "formDataValues");
  
  // Update current form data by merging with previous data
  const updatedFormData = { ...currentFormData, ...formData };
  console.log(updatedFormData, "updatedFormData");
  setCurrentFormData(updatedFormData);
  
  // Handle game selection change
  if (formData.game_id && formData.game_id !== currentFormData.game_id) {
    setSelectedGame(formData.game_id);
    
    // Validate game selection
    const selectedGameData = games.find(game => game.id === formData.game_id);
    if (selectedGameData && selectedGameData.name.toLowerCase() !== 'football') {
      setErrorMessage('Not have leagues list you can only selected as football value');
      setShownotification(true);
      setFieldsDisabled(true);
      return;
    } else {
      setFieldsDisabled(false);
    }
  }
  
  // Handle league selection change for auto-filling colors 
  // CHANGED: Removed the mode restriction to allow auto-fill in edit mode as well
  if (formData.league_name && formData.league_name !== currentFormData.league_name) {
    console.log(formData, "league_name");
    const selectedLeague = leagues?.find(league => league.id === formData.league_name);
    console.log(selectedLeague, "selectedLeague11");
    if (selectedLeague) {
      const leagueId = selectedLeague.system_league_id || selectedLeague.league_id;
      console.log("Selected league ID:", leagueId);
      const predefinedColors = predefinedLeagueColors[leagueId];
      console.log("Predefined colors found:", predefinedColors);
      
      // Check if this league has predefined colors (78, 2, 140, 871)
      if (predefinedColors) {
        console.log("Auto-filling colors for league ID:", leagueId);
        const newColors = { ...predefinedColors };
        setFormColors(newColors);
        
        // Update current form data with new colors
        const updatedWithColors = { ...updatedFormData, ...newColors };
        setCurrentFormData(updatedWithColors);
      } else {
        // Clear colors for non-predefined leagues (only in create mode)
        if (mode !== 'view' && mode !== 'edit') {
          setFormColors();
          
          const updatedWithColors = { 
            ...updatedFormData,  
            card_color: '',
            progress_bar_color: '',
            btn_text_color: '',
            btn_background_color: '' 
          };
          setCurrentFormData(updatedWithColors);
        } else if (mode === 'edit') {
          // In edit mode, revert to original fetched data colors for non-predefined leagues
          console.log("Reverting to original colors for non-predefined league");
          const originalColors = {
            card_color: currentLeagueData.card_color,
            btn_text_color: currentLeagueData.btn_text_color,
            btn_background_color: currentLeagueData.btn_background_color,
            progress_bar_color: currentLeagueData.progress_bar_color
          };
          
          setFormColors(originalColors);
          
          const updatedWithOriginalColors = { ...updatedFormData, ...originalColors };
          setCurrentFormData(updatedWithOriginalColors);
        }
      }
    }
  }
}}
              formInputs={[
                ...leagueFormSystem({
                  leagues,
                  games,
                  mode, // Pass mode to form
                  predefinedLeagueColors,
                  defaultColors,
                  formColors: formColors,
                  currentFormData: currentFormData,
                  fieldsDisabled: fieldsDisabled 
                }),
              ]}
            />
          ) : (
            <TransForm
              key={formKey}
              submitAction={onSubmit}
              data={getFormData()}
              mode={mode}
              formInputs={leagueFormManual({ 
                mode, 
                games,
                currentFormData: currentFormData
              })}
            />
          )}
        </>
      )}

      {/* Show loading message when data is being fetched */}
      {(ismanual !== '' || mode === 'view' || mode === 'edit') && (leagues.length === 0 || games.length === 0) && (
        <Box sx={{ px: 6, py: 3, textAlign: 'center' }}>
          <Typography>Loading form data...</Typography>
        </Box>
      )}

      <ModalPopUp
        openpopup={popup}
        setPopup={setPopup}
        title={'Confirm the action ?'}
        subTitle={mode === 'edit' 
          ? 'Are you sure you want to update this league with the given details?' 
          : 'Are you sure you want to create a new league with the given details?'
        }
        onClick={SubmitTeams}
        save={mode === 'edit' ? 'Yes, Update' : 'Yes, Create'}
        cancel={'Exit'}
      />
      <Notification message={errorMessage} setopen={setShownotification} type={'error'} show={shownotification} />
    </Box>
  );
};